export default __webpack_public_path__ + "static/media/social-03.237f2985.webp";